import { useContext } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { ExamContext } from '@app.feature/exam/context/ExamContext'
import usePagination, { PaginatorPiece } from 'hooks/usePagination'
import ArrowLeftIcon from 'svgIcons/ArrowLeft'
import ArrowRightIcon from 'svgIcons/ArrowRight'

interface IFProps {
  totalCount: number
}

const Pagination = ({ totalCount }: IFProps) => {
  const { handleCheckReservation } = useContext(ExamContext)

  const router = useRouter()
  const { query } = router

  const setActivePage = (clickedPage: number) => {
    handleCheckReservation({
      onReservated: () => {
        router.replace(
          {
            query: {
              ...router.query,
              page: clickedPage,
            },
          },
          undefined,
          { shallow: true },
        )
      },
    })
  }

  const { goToPage, activePage, computeVisiblePieces } = usePagination({
    activePage: Number(query.page as string) || 1,
    setActivePage,
    numberOfPages: Math.ceil(totalCount / 6),
    maxButtons: 5,
  })

  const visiblePieces = computeVisiblePieces({
    maxButtons: 5,
    activePage: Number(query.page as string) || 1,
    numberOfPages: Math.ceil(totalCount / 6),
  })

  return (
    <StyledWrapper>
      {visiblePieces.map((piece: PaginatorPiece) => {
        if (piece.type === 'next') {
          return (
            <button
              key="next"
              disabled={piece.isDisabled}
              className="button-arrow-next"
              onClick={() => goToPage(piece.pageNumber)}
            >
              <ArrowRightIcon className="icon-arrow" />
            </button>
          )
        }
        if (piece.type === 'previous') {
          return (
            <button
              key="previous"
              disabled={piece.isDisabled}
              className="button-arrow-previous"
              onClick={() => goToPage(piece.pageNumber)}
            >
              <ArrowLeftIcon className="icon-arrow" />
            </button>
          )
        }
        if (piece.type === 'page-number') {
          return (
            <button
              key={piece.pageNumber}
              className={`button-page-number' ${
                activePage === piece.pageNumber ? 'active-page' : ''
              }`}
              onClick={() => goToPage(piece.pageNumber)}
            >
              {piece.pageNumber}
            </button>
          )
        }
        return null
      })}
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  display: flex;
  > button {
    width: 39px;
    height: 39px;
    margin: 0 0 0 6px;
    border-radius: 5px;
    border: solid 1px #dedede;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: -0.6px;
    color: #333;
    cursor: pointer;
    &:disabled {
      color: #999;
      cursor: default;
    }

    &.active-page {
      font-weight: bold;
      color: #004eff;
    }
  }
`

export default Pagination
